import logo from './logo.svg';
import './App.css';
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from './components/Header';
import Banner from './components/Banner';
import FeatureList from './components/FeatureList';
import HomeProduct from './components/HomeProduct';
import Footer from './components/Footer';
import SignInForm from './components/SignInForm';
import SignUpForm from './components/SignUpForm';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cart from './components/Cart';
import Thankyou from './components/Thankyou';
import CustomerOrders from './components/CustomerOrders';

function App() {
  return (
    <BrowserRouter>
      <React.Fragment>
        <Header />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <>
                <Banner />
                <FeatureList />
                <HomeProduct />
              </>
            }
          />
          <Route exact path="/account/signin" element={<SignInForm />} />         
          <Route exact path="/account/signup" element={<SignUpForm />} />
          <Route exact path="cart" element={<Cart/>} />
          <Route exact path="thankyou" element={<Thankyou/>} />
          <Route exact path="/account/orders" element={<CustomerOrders/>} />
          
        </Routes>
        <Footer />
        <ToastContainer position="top-right" autoClose={1000} />
      </React.Fragment>
    </BrowserRouter>
  );
}

export default App;
